import classNames from 'classnames';
import { useField } from 'formik';
import { FC, useCallback, useMemo, useState } from 'react';
import * as Yup from 'yup';
import YupPassword from 'yup-password';

import { IconCheck } from 'src/general/Icons/IconCheck';
import { IconClose } from 'src/general/Icons/IconClose';
import { IconHide } from 'src/general/Icons/IconHide';
import { IconShow } from 'src/general/Icons/IconShow';

import { FormikInput } from './FormikInput';
import classes from './FormikInput.module.scss';
import { FormikInputTextProps } from './FormikInput.types';

type PasswordKey = 'minUppercase' | 'minLowercase' | 'minNumber' | 'min';

const errorMessages: { [key in PasswordKey]: string } = {
  min: 'Must contain at least 8 characters',
  minUppercase: 'Must contain at least 1 uppercase letter',
  minLowercase: 'Must contain at least 1 lowercase letter',
  minNumber: 'Must contain at least 1 number',
};

YupPassword(Yup); // extend yup

export const FormikInputPasswordValidation = Yup.string()
  .min(8, ' ')
  .minLowercase(1, ' ')
  .minUppercase(1, ' ')
  .minNumbers(1, ' ')
  .required(' ');

interface PasswordMessage {
  key: PasswordKey;
  valid: boolean;
}

interface Props extends FormikInputTextProps {
  classNameWrapper?: string;
  withHelpText?: boolean;
}

export const FormikInputPassword: FC<Props> = (props) => {
  const [field, meta] = useField(props.name);
  const [displayValidation, setDisplayValidation] = useState<boolean>(false);
  const [type, setType] = useState<'text' | 'password'>('password');

  const messages: PasswordMessage[] = useMemo(() => {
    const messages: PasswordMessage[] = [
      { key: 'minUppercase', valid: true },
      { key: 'minLowercase', valid: true },
      { key: 'minNumber', valid: true },
      { key: 'min', valid: true },
    ];
    try {
      FormikInputPasswordValidation.validateSync(field.value, { abortEarly: false });
    } catch (validationErrors: any) {
      if ('inner' in validationErrors) {
        (validationErrors as Yup.ValidationError).inner.forEach((error) => {
          const key = error.type;
          const messageIndex = messages.findIndex((item) => item.key === key);
          if (messageIndex >= 0) {
            messages[messageIndex].valid = false;
          }
        });
      }
    }
    return messages;
  }, [field.value]);

  const onFocus = useCallback(() => {
    console.log('boom');
    if (!displayValidation) {
      setDisplayValidation(true);
    }
  }, [displayValidation]);

  return (
    <div className={classNames(classes.passwordWrapper, props.classNameWrapper)}>
      <FormikInput
        {...props}
        type={type}
        inputProps={{ onFocus }}
        inputActionButton={{
          Icon: type === 'text' ? IconHide : IconShow,
          onClick: () => setType(type === 'text' ? 'password' : 'text'),
        }}
      />
      {props.withHelpText && displayValidation && (
        <ul className={classes.passwordHelpText}>
          {messages.map(({ key, valid }) => (
            <li
              key={key}
              className={classNames(classes.passwordHelpTextItem, {
                [classes.passwordHelpTextValid]: valid,
                [classes.passwordHelpTextInvalid]: !valid && meta.touched,
              })}
            >
              {valid ? <IconCheck /> : <IconClose />}
              <span className={classes.passwordHelpTextMessage}>{errorMessages[key]}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
